const premiumText = '<div class="premium variant-title">Premium Fabrics</h1>'
const goldText = '<div class="gold variant-title">Classic Fabric</h1>'
const silverText = '<div class="silver variant-title">Leather</h1>'
const finishText = '<div class="finish variant-title">Finish</h1>'
const performanceText = '<div class="performance-fabric variant-title">Performance Fabric</h1>'
const seatText = '<div class="seat-fabric variant-title">Seats Fabric</h1>'
const fabricText = '<div class="fabric variant-title">Fabric</div>'


const premiumStart = document.querySelector('.Premiumstart')
const goldStart = document.querySelector('.Goldstart')
const silverStart = document.querySelector('.Silverstart')
const finishStart = document.querySelector('.Finishstart')
const performanceStart = document.querySelector('.Performstart')
const seatStart = document.querySelector('.Seatstart')
const fabricStart = document.querySelector('.Fabricstart')

if(premiumStart){
premiumStart.insertAdjacentHTML('beforebegin', premiumText) 
}

if(goldStart){
goldStart.insertAdjacentHTML('beforebegin', goldText)
  }

if(silverStart){
silverStart.insertAdjacentHTML('beforebegin', silverText)
  }

if(finishStart){
finishStart.insertAdjacentHTML('beforebegin', finishText)
  }
if(fabricStart){
  fabricStart.insertAdjacentHTML('beforebegin', fabricText)
}

if(performanceStart){
  performanceStart.insertAdjacentHTML('beforebegin', performanceText)
}

if(seatStart){
  seatStart.insertAdjacentHTML('beforebegin', seatText)
}

